import Vue from "vue";

// The event bus is just another vue instance that is shared between all components
export default new Vue();
